import { render, staticRenderFns } from "./feishuForm.vue?vue&type=template&id=339866be&scoped=true"
import script from "./feishuForm.vue?vue&type=script&lang=js"
export * from "./feishuForm.vue?vue&type=script&lang=js"
import style0 from "./feishuForm.vue?vue&type=style&index=0&id=339866be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339866be",
  null
  
)

export default component.exports